import { Button } from '@/components/button/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/tooltip/tooltip'

import { cn } from '@/lib/utils'

export interface SubmitButtonProps {
  disabled?: boolean
  loading?: boolean
  onClick: VoidFunction
}

export const SubmitButton = ({ disabled, loading, onClick }: SubmitButtonProps) => {
  return !disabled ? (
    <Button type="button" variant="default" loading={loading} className={cn('w-[120px]')} onClick={onClick}>
      Submit
    </Button>
  ) : (
    <TooltipProvider delayDuration={250}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="default"
            className={cn('w-[120px]', 'cursor-default opacity-50 hover:bg-primary')}
          >
            Submit
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="end" className={cn('w-fit')}>
          <p className={cn('text-sm')}>Please review all documents before submitting</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
